// extracted by mini-css-extract-plugin
module.exports = {"error-boundary-container":"error-boundary-container___3Cnh8"};